import * as React from 'react';
import { cn } from '@/lib/utils';

interface ScrollAreaProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Max height for the scrollable region */
  maxHeight?: string;
}

/** Lightweight scroll area with styled scrollbar */
const ScrollArea = React.forwardRef<HTMLDivElement, ScrollAreaProps>(
  ({ className, children, maxHeight, style, ...props }, ref) => (
    <div
      ref={ref}
      className={cn('overflow-y-auto', className)}
      style={{ maxHeight, ...style }}
      {...props}
    >
      {children}
    </div>
  ),
);
ScrollArea.displayName = 'ScrollArea';

export { ScrollArea };
